import axios from 'axios'
import env from "../../env"
// import Swal from 'sweetalert2'

export const fetchOtpAppSms = (appId, category) => {
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/otpData/${appId}/${category}`,
        })
          .then(response => {
            dispatch({ type: 'SET_OTP_APP_SMS', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const fetchOtpAppWa = (appId, category) => {
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/otpData/${appId}/${category}`,
        })
          .then(response => {
            dispatch({ type: 'SET_OTP_APP_WA', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const addUpdateOtpApp = (payload) => {
  return (dispatch, getState) => {
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/auth/otp/${payload.appId}`,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      },
      data: payload
    })
      .then(response => {
        if (response.data.category === "smsOTP") {
          dispatch({ type: 'SET_OTP_APP_SMS', payload: response.data})          
        } else if (response.data.category === "waOTP") {
          dispatch({ type: 'SET_OTP_APP_WA', payload: response.data})                    
        }
      })
      .catch(error => {
          dispatch({ type: 'SET_ERROR', payload: error })
      })
      .finally(_ => {
          dispatch({ type: 'SET_LOADING', payload: false })
      })
  }
}

export const updateOtpStatus = (payload) => {
  return (dispatch, getState) => {
    axios({
      method:'patch',
      url: `${env.REACT_APP_BE_URL}/auth/otp/${payload.appId}/status`,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      },
      data: payload
    })
      .then(response => {
        if (response.data.category === "smsOTP") {
          dispatch({ type: 'SET_OTP_APP_SMS', payload: response.data})          
        } else if (response.data.category === "waOTP") {
          dispatch({ type: 'SET_OTP_APP_WA', payload: response.data})                    
        }
      })
      .catch(error => {
          dispatch({ type: 'SET_ERROR', payload: error })
      })
      .finally(_ => {
          dispatch({ type: 'SET_LOADING', payload: false })
      })
  }
}

export const sendOtp = (payload) => {
  return (dispatch, getState) => {
    // Swal.fire({
    //   title: 'Processing...',
    //   html: 'Please wait...',
    //   allowEscapeKey: false,
    //   allowOutsideClick: false,
    //   didOpen: () => {
    //     Swal.showLoading()
    //   }
    // });
    dispatch({ type: 'SET_LOADING_OTP', payload: true })
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/otp/sendToUserPhone`,
      headers: {
        authorization: payload.apiKey
      },
      data: payload
    })
      .then(response => {
          dispatch({ type: 'SET_CUSTOMER_APP', payload: response.data})
      })
      .catch(error => {
          dispatch({ type: 'SET_ERROR_OTP', payload: error })
      })
      .finally(_ => {
          // Swal.close()
          dispatch({ type: 'SET_LOADING_OTP', payload: false })
      })
  }
}

export const fetchWhatsappQR = (otpAppId) => {
  return (dispatch, getState) => {
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/connect-whatsapp`,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      },
    })
      .then(response => {
          console.log(response,'<<<<<llllllll');
          // dispatch({ type: 'SET_CUSTOMER_APP', payload: response.data})
      })
      .catch(error => {
        console.log(error,'<<<Llkkk');
          // dispatch({ type: 'SET_ERROR', payload: error })
      })
      .finally(_ => {
          // dispatch({ type: 'SET_LOADING', payload: false })
      })
  }
}